import React, { useMemo } from "react";
import { HiddenVisually, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { SPACER_PADDED } from "@flights/constants";
import useCabinClassName from "../../../../hooks/useCabinClassName.js";
import Frame from "../../Frame/index.js";
import styles from "./TimelineLegInfo.module.css";
import useSearchCabinClass from "../../../../hooks/useSearchCabinClass.js";
import { formattingUtils } from "@flights/web-api-utils-universal";
export const TimelineLegInfo = ({ leg }) => {
    const i18n = useI18n();
    const cabinClassName = useCabinClassName();
    const { searchCabinClass } = useSearchCabinClass();
    const { carrier, carrierLogo, cabinClass, operatingCarrier, operatingCarrierDisclosureText, flightDurationMinutes } = leg;
    const isMismatchCabinClass = useMemo(() => !!searchCabinClass && searchCabinClass !== cabinClass, [searchCabinClass, cabinClass]);
    return (React.createElement(Frame, { direction: "row" },
        React.createElement(Frame, { className: styles.logoColumn, attributes: { "data-testid": "timeline_leg_info_logo" } },
            React.createElement("img", { role: "presentation", alt: carrier, src: carrierLogo, className: styles.carrierLogoImg })),
        React.createElement(Frame, { className: styles.textColumn },
            React.createElement(Text, { variant: "small_1", attributes: { "data-testid": "timeline_leg_info_carrier" } }, carrier),
            operatingCarrierDisclosureText && (React.createElement(Text, { variant: "small_1" }, i18n.trans(t("flights_airline_operated_by", {
                variables: {
                    airline_name: operatingCarrierDisclosureText
                }
            })))),
            !operatingCarrierDisclosureText && operatingCarrier && (React.createElement(Text, { variant: "small_1" }, i18n.trans(t("flights_airline_operated_by", {
                variables: {
                    airline_name: operatingCarrier
                }
            })))),
            React.createElement(Text, { variant: "small_1", attributes: { "data-testid": "timeline_leg_info_flight_number_and_class" } },
                getLegFullFlightNumber(leg),
                SPACER_PADDED,
                isMismatchCabinClass ? (React.createElement("span", { style: { backgroundColor: "var(--bui_color_callout_background_alt)" } }, cabinClassName(cabinClass))) : (cabinClassName(cabinClass))),
            React.createElement(Text, { variant: "small_1", attributes: {
                    "data-testid": "timeline_leg_info_duration",
                    "aria-hidden": "true"
                } }, i18n.trans(t("flights_itinerary_duration", {
                variables: {
                    duration: formattingUtils.flightDuration(flightDurationMinutes, i18n)
                }
            }))),
            React.createElement(HiddenVisually, null, i18n.trans(t("flights_itinerary_duration", {
                variables: {
                    duration: formattingUtils.flightDurationAria(flightDurationMinutes, i18n)
                }
            }))))));
};
const getLegFullFlightNumber = (leg) => {
    return `${leg.carrierCode}${leg.flightNumber}`;
};
